import { __awaiter, __decorate, __param } from 'tslib';
import { Injectable, Optional, SkipSelf, NgModule } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';

let AlertDocumentService = class AlertDocumentService {
    constructor(alertController) {
        this.alertController = alertController;
    }
    imagemLarge(size) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!size) {
                size = 5;
            }
            const alert = yield this.alertController.create({
                cssClass: 'my-custom-class',
                header: 'Atenção! Imagem maior que ' + size + ' MB',
                message: 'A sua imagem está muito grande. Será necessario tirar uma nova foto.  ',
                buttons: ['OK'],
            });
            yield alert.present();
        });
    }
    documentLarge(size) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!size) {
                size = 5;
            }
            const alert = yield this.alertController.create({
                cssClass: 'my-custom-class',
                header: 'Atenção! Documento maior que ' + size + ' MB',
                message: 'O seu documento está muito grande. Será necessario fazer o upload de um novo documento.',
                buttons: ['OK'],
            });
            yield alert.present();
        });
    }
};
AlertDocumentService.ctorParameters = () => [
    { type: AlertController }
];
AlertDocumentService = __decorate([
    Injectable()
], AlertDocumentService);

let AlertAccountService = class AlertAccountService {
    constructor(alertController) {
        this.alertController = alertController;
    }
    existCpf() {
        return __awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                cssClass: 'my-custom-class',
                header: 'Atenção!',
                message: 'Seu cadastro já foi iniciado. Recuperamos seus dados já preenchidos, e você pode continuar de onde parou.',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    invalidCode() {
        return __awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                cssClass: 'my-custom-class',
                header: 'Atenção!',
                message: 'O código digitado não é válido. Verifique o código recebido e tente novamente.',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    expiredCode() {
        return __awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                cssClass: 'my-custom-class',
                header: 'Atenção!',
                message: 'O código digitado expirou. Clique em reeviar para gerar um novo código.',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
};
AlertAccountService.ctorParameters = () => [
    { type: AlertController }
];
AlertAccountService = __decorate([
    Injectable()
], AlertAccountService);

var UiBsAlertModule_1;
let UiBsAlertModule = UiBsAlertModule_1 = class UiBsAlertModule {
    constructor(parentModule) {
        //.....
    }
    static forRoot(config) {
        return {
            ngModule: UiBsAlertModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsAlertModule.ctorParameters = () => [
    { type: UiBsAlertModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsAlertModule = UiBsAlertModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [],
        providers: [
            AlertDocumentService,
            AlertAccountService
        ]
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsAlertModule);

/*
 * Public API Surface of ui-bs-alert
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertAccountService, AlertDocumentService, UiBsAlertModule };
//# sourceMappingURL=wlp-ui-bs-alert.js.map
